import { CSSObject } from '@chakra-ui/react';

export const StyledDatePicker: CSSObject = {
  '&&&': {
    '.chakra-input, .react-date-picker__wrapper': {
      h: '38px',
      background: 'blackAlpha.500',
      color: 'white',
      borderRadius: 'md',
      transition: 'all .2s ease-in-out',
      fontSize: 'xs',
      border: 'none',
      fontFamily: 'body',
      px: '2',
      'input, span': {
        fontFamily: 'body',
        fontWeight: 'normal',
      },
      button: {
        color: 'beta.300',
      },
      _hover: {
        border: '1px solid #adf106',
      },
    },
  },
};
